/* eslint-disable react/jsx-props-no-spreading */
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';

import ColumnItem, { ColumnItemProps } from './ColumnItem';

function ColumnItemSortable(props: ColumnItemProps) {
  const { column } = props;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: column.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div key={column.id} style={style} ref={setNodeRef} {...attributes}>
      <ColumnItem {...props} listeners={listeners} />
    </div>
  );
}

export default ColumnItemSortable;
